import { UID, VAR } from 'shared/api/query/constants';
import { notHasFilter } from 'shared/api/query/filter';
import { property, propertyValue } from 'shared/api/query/configs.json';
import { reverseEdge } from 'shared/api/query/edges';

export const makeRichTextFn = (childrenFn, varIdFn) => (scope, index) => {
  if (scope.isEmpty !== true) {
    return { filterTrees: [], varBlocks: [] };
  }

  const varName = varIdFn(index);
  const varBlocks = [
    {
      alias: VAR,
      uid: [scope.property.uid],
      model: property.model,
      func: { name: UID },
      children: [
        {
          attr: reverseEdge(propertyValue.edges.property),
          model: propertyValue.model,
          filter: notHasFilter(propertyValue.edges.document),
          children: childrenFn(varName),
        },
      ],
    },
  ];
  const filterTree = {
    func: {
      name: UID,
      needsVar: [{ name: varName, typ: 1 }],
    },
  };
  return { filterTrees: [filterTree], varBlocks };
};

export const directPropRichTextFn = (scope) => {
  if (scope.isEmpty !== true) {
    return { filterTrees: [], varBlocks: [] };
  }

  return { filterTrees: [notHasFilter(scope.directProperty.edgeName)], varBlocks: [] };
};
